import React from 'react';
import { List } from 'semantic-ui-react'
// import {graphql} from 'react-apollo';

//utils
// import queries from '../../../src/utils/queries'

import TitDer from '../../components/funcionales/titder';

import general from '../../modulos/general';

const Cliente = ({styles, elemento, direccion1, direccion2, telContact, cicloF, tarifaCli, colorServicio, ofertaCli}) => {
  let fechaUltPago = elemento.fechaUltPago?elemento.fechaUltPago.substr(0, 10):""
  let valorUltPago = elemento.valorUltPago?"$" + general.formatNum(elemento.valorUltPago.toString()):""
  // console.log(elemento, tarifaCli)
  return(
    // <div>
    <div style={styles.subElemLis_1}>
      <div className="ui five column stackable grid">
        <div className="row container" style={{paddingBottom: '0em'}}>
          <div className="column" style={{width: '5%', paddingRight: '0em', marginRight: '0em'}}>
            {elemento.sexoCliente==='Masculino' && 
              <img className="left floated ui avatar image" style={{marginRight: '0em'}} src="images/hombre.png" alt="imagen"></img>
            }
            {elemento.sexoCliente==='Femenino' && 
              <img className="left floated ui avatar image" style={{marginRight: '0em'}} src="images/mujer.png" alt="imagen"></img>
            }
          </div>
          <div className="column" style={{width: '55%', paddingLeft: '0em', fontSize: '1.4em'}}>
            <p style={{...styles.elemLis_1, color: colorServicio}}>
              {elemento.contrato} {elemento.nombreCliente} {elemento.apellidoCliente}
            </p>
          </div>
          <div className="column" style={{width: '19%', fontSize: '1.7em'}}>
            {/* &nbsp;&nbsp;&nbsp;&nbsp; */}
            <p style={styles.elemLis_1}>
              {elemento.estadoCliente==='NUEVO' && <b style={styles.elemLis_3}>{elemento.estadoCliente}</b>}
              {elemento.estadoCliente==='DESCONECTADO' && <b style={styles.elemLis_3}>{elemento.estadoCliente}</b>}
              {(elemento.estadoCliente!=='NUEVO'&&elemento.estadoCliente!=='DESCONECTADO') && <b style={styles.elemLis_2}>{elemento.estadoCliente}</b>}
            </p>
          </div>
          <div className="column" style={{width: '5%'}}>
            <p style={styles.elemLis_1}>Saldo:
              {/* <b style={styles.elemLis_1}>Saldo:</b> */}
            </p>
          </div>
          <div className="column" style={{width: '12%'}}>
            <p>
              <span style={{background: 'white', width: '100%', textAlign: 'center'}} className='ui basic label'>
                <span style={{color: '#302b63', fontSize: '1.2em'}}> ${general.formatNum(elemento.saldoPendiente.toString())}</span>
              </span>
            </p>
          </div>
        </div>

        <div className="row container" style={{paddingTop: '0em', paddingBottom: '0em'}}>
          <div className="column" style={{width: '79%'}}>
            <p style={styles.detalle}>{direccion1}{direccion1?', ':''}{direccion2}</p>
          </div>
          <div className="column" style={{width: '5%'}}>
            <p style={{color: 'white', fontWeight: 'normal'}}>Renta:
              {/* <b style={styles.elemLis_1}>Renta:</b> */}
            </p>
          </div>
          <div className="column" style={{width: '12%', textAlign: 'center'}}>
            <p style={styles.elemLis_1}>
              <b style={styles.elemLis_1}>${general.formatNum(elemento.cargoMensual.toString())}</b>
            </p>
          </div>
        </div>

        <div className="row container" style={{paddingTop: '0em', paddingBottom: '0em'}}>
          <div className="column" style={{width: '50%'}}>
            <p style={{...styles.detalle, color: elemento.datosConfirmados==="NO"?'#DCE35B':'#61CF1D'}}>
              Tel contacto: {telContact}
            </p>
          </div>
          <div className="column" style={{width: '29%'}}>
            <p style={styles.detalle}>Ciclo fact: {cicloF}</p>
          </div>
          <div className="column" style={{width: '5%'}}>
            <p style={{color: 'white', fontWeight: 'normal'}}>Mora:</p>
          </div>
          <div className="column" style={{width: '12%', textAlign: 'center'}}>
            <p style={styles.elemLis_1}>{general.formatNum(elemento.diasMora.toString())}</p>
          </div>
        </div>

        <div className="row container" style={{paddingTop: '0em', paddingBottom: '0em'}}>
          <div className="column" style={{width: '50%'}}>
            <p style={{...styles.detalle, color: elemento.envFraCorreo==="N"?'#DCE35B':'#D113C8'}}>
              {tarifaCli}
            </p>
          </div>
          {/* <div className="column" style={{width: '29%'}}>
            <p style={styles.detalle}>{ofertaCli}</p>
          </div> */}

          <div className="column" style={{width: '29%', color: 'white'}}>
            <p style={styles.detalle}>{elemento.infAdic1?elemento.infAdic1:""}&nbsp;&nbsp;&nbsp;{elemento.codigoMarquilla?"Marq: "+elemento.codigoMarquilla:""}</p>
          </div>

          <div className="column" style={{width: '8%'}}>
            <p style={{color: 'white', fontWeight: 'normal'}}>Ul pago:</p>
          </div>
          <div className="column" style={{width: '12%'}}>
            <p style={styles.elemLis_1}>{fechaUltPago}</p>
          </div>
        </div>

        <div className="row container" style={{paddingTop: '0em', paddingBottom: '0em'}}>
          <div className="column" style={{width: '85%'}}>
            {!elemento.numeroOdeDX && 
              <p style={styles.detalle}>{elemento.observaciones}</p>
            }
            {elemento.numeroOdeDX!==0 && 
              <p style={styles.elemLis_3}>!! TIENE SERVICIOS DX EN PROCESO DE DX MASIVA No. {elemento.numeroOdeDX} !!</p>
            }
          </div>
          <div className="column" style={{width: '12%', textAlign: 'center'}}>
            <p style={styles.elemLis_1}>{valorUltPago}</p>
          </div>
        </div>

      </div>

    {/* <p style={styles.elemLis_1}>{elemento.contrato} {elemento.nombreCliente} {elemento.apellidoCliente}
    {elemento.estadoCliente==='NUEVO' && <b style={styles.elemLis_3}> - {elemento.estadoCliente}</b>}
    {elemento.estadoCliente==='DESCONECTADO' && <b style={styles.elemLis_3}> - {elemento.estadoCliente}</b>}
    {(elemento.estadoCliente!=='NUEVO'&&elemento.estadoCliente!=='DESCONECTADO') && <b style={styles.elemLis_2}> - {elemento.estadoCliente}</b>}
    <b style={styles.elemLis_1}> - $Mensual ${general.formatNum(elemento.cargoMensual.toString())}</b>
    <b style={styles.elemLis_3}> - $Saldo pendiente ${general.formatNum(elemento.saldoPendiente.toString())}</b>
    </p> */}
    </div>
  )};

  // const Estado = ({styles, elemento}) => <i>Estado: {elemento.estadoCliente}</i>
  
// const ServiciosNombreResumido = props => <p>{props.elemento.codigoServicio} ={">"} {props.elemento.nombreResumido}</p>;
const ServiciosNombreResumido = props => {
  var servDet = ""
  try{
    servDet = props.elemento.codigoServicio + " => " + props.elemento.nombreResumido
  }catch (e) {
    servDet = ""
  }
  return(
    <p style={props.styles.detalle}>{servDet}</p>
  )
};

const DetalleNivel2 = props => <ServiciosNombreResumido styles={props.styles} elemento={props.elemento} />;

const DetalleNivel1 = ({styles, empresaArchFE, elemento, handleClickidLista}) => {
  // console.log(elemento.infAdic1)
  // const Nivel2Detalle
  // const tarCl = elemento.tarifa
  // console.log(tarCl._id)
  let servCl = []
  if(elemento.tarifa._id){
    servCl = elemento.tarifa.servicios
  }

//Traer dirección
  let linea1DNN = ""
  let linea2DNN = ""
  let linea3DNN = ""
  let linea4DNN = ""
  let direccion1 = ""
  let direccion2 = ""

  if(elemento.direccion.descrTipoVia1){
    linea1DNN = `${elemento.direccion.descrTipoVia1?elemento.direccion.descrTipoVia1:""}
      ${elemento.direccion.numeroTipoVia1?elemento.direccion.numeroTipoVia1:""}
      ${elemento.direccion.descrTipoVia2?elemento.direccion.descrTipoVia2:""}
      ${elemento.direccion.numeroTipoVia2?elemento.direccion.numeroTipoVia2:""}
      ${elemento.direccion.numeroTipoVia2F?elemento.direccion.numeroTipoVia2F:""}
      ${elemento.direccion.descrTipoUnd1?elemento.direccion.descrTipoUnd1:""}
      ${elemento.direccion.numeroTipoUnd1?elemento.direccion.numeroTipoUnd1:""}
      ${elemento.direccion.descrTipoUnd2?elemento.direccion.descrTipoUnd2:""}
      ${elemento.direccion.numeroTipoUnd2?elemento.direccion.numeroTipoUnd2:""}`

      linea2DNN = `${elemento.direccion.descrTiUndMat?elemento.direccion.descrTiUndMat:""}
      ${elemento.direccion.descrUndMat?elemento.direccion.descrUndMat:""}`

      linea3DNN = `${elemento.dirmayor.descrDpto?elemento.dirmayor.descrDpto:""}
        ${elemento.dirmayor.ciudades.nombreCiudad?", " + elemento.dirmayor.ciudades.nombreCiudad:""}`
    
      linea4DNN = `${elemento.dirmayor.ciudades.zonas.nombreZona?", Zona: " + elemento.dirmayor.ciudades.zonas.nombreZona:""}
        ${elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio?", Barrio: " + elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio:""}`

      direccion1 = linea1DNN + ' ' + linea2DNN
      direccion2 = linea3DNN + ' ' + linea4DNN
  }else{
    if(elemento.dirmayor&&elemento.dirmayor.ciudades&&elemento.dirmayor.ciudades.nombreCiudad){
      direccion2 = `${elemento.dirmayor.descrDpto?elemento.dirmayor.descrDpto:""}
        ${elemento.dirmayor.ciudades.nombreCiudad?", " + elemento.dirmayor.ciudades.nombreCiudad:""}`
    }
  }
  
  let telContact = `${elemento.telefono1?elemento.telefono1:""}
  ${elemento.telefono2?" / " + elemento.telefono2:""}
  ${elemento.telefono3?" / " + elemento.telefono3:""}`
  if(elemento.datosConfirmados==="SI"){
    telContact += ` => Confirmados`
  }
  let cicloF = `${elemento.cicloFact?elemento.cicloFact:""}`

  // let tarifaCli = `${elemento.tarifa.codigoTarifa?'Tarifa: ' + elemento.tarifa.codigoTarifa + ' '+ elemento.tarifa.descrTarifa:""}
  // ${elemento.oferta.codigoOferta?"Oferta: " + elemento.oferta.codigoOferta + ' '+ elemento.oferta.descrOferta:""}`

  let tarifaCli = `${elemento.tarifa.codigoTarifa?'Tarifa: ' + elemento.tarifa.codigoTarifa + ' '+ elemento.tarifa.descrTarifa:""}`

  if(elemento.envFraCorreo==="S"){
    if(empresaArchFE!=="codisert"){
      tarifaCli += ` => ENVIAR factura por correo`
    }else{
      tarifaCli += ` => ${elemento.grupoaf.descrGrupoAfin}`
    }
  }
  let colorServicio = "#ffffff"
  if(elemento.tarifa&&elemento.tarifa.servicios){
    for(let ii=0; ii<elemento.tarifa.servicios.length; ii++){
      if(elemento.tarifa.servicios[ii].colorServicio&&elemento.tarifa.servicios[ii].colorServicio!=="#ffffff"){
        colorServicio = elemento.tarifa.servicios[ii].colorServicio
      }
    }
  }

  let ofertaCli = `${elemento.oferta.codigoOferta?"Oferta: " + elemento.oferta.codigoOferta + ' '+ elemento.oferta.descrOferta:""}`

  // console.log(tarifaCli, elemento.contrato)
  // console.log(elemento)

  const  Nivel2Detalle = servCl.map((elemento, i) => <DetalleNivel2 styles={styles} elemento={elemento} key={i} />);
  // }else{
  //   const servCl = []
  //   Nivel2Detalle = servCl.map((elemento, i) => <DetalleNivel2 styles={styles} elemento={elemento} key={i} />);
  // }
  return (
    <div className="ui middle aligned animated celled link list" style={styles.detCliente}>
      <div className="item">
        <List.Item onClick={(ev)=>handleClickidLista(ev, elemento)}>
            <List.Header>
                <div className="right floated content" style={styles.elemLis_3}>
                    <div>{Nivel2Detalle}</div>
                </div>
            </List.Header>
            {/* {elemento.sexoCliente==='Masculino' && 
              <img className="left floated ui avatar image" src="images/hombre.png" alt="imagen"></img>
            }
            {elemento.sexoCliente==='Femenino' && 
              <img className="left floated ui avatar image" src="images/mujer.png" alt="imagen"></img>
            } */}
            <List.Header>
                <div className="floated content" style={styles.subElemLis_1}>
                    <a className="header"><Cliente styles={styles} elemento={elemento}
                        direccion1={direccion1} direccion2={direccion2} telContact={telContact}
                        cicloF={cicloF} tarifaCli={tarifaCli} colorServicio={colorServicio} ofertaCli={ofertaCli}/></a>
                    {/* <p style={styles.detalle}>{direccion1}</p> */}
                    {/* <p style={styles.detalle}>{direccion2}</p> */}
                    {/* <p style={styles.detalle}>Teléfonos de contacto: {telContact}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <b style={styles.elemLis_2}>Ciclo de facturación: {cicloF}</b>
                    </p> */}
                    {/* <p style={styles.detalle}>{tarifaCli}</p>
                    {!elemento.numeroOdeDX && 
                      <p style={styles.detalle}>{elemento.observaciones}</p>
                    }
                    {elemento.numeroOdeDX!==0 && 
                      <p style={styles.elemLis_3}>!! TIENE SERVICIOS DX EN PROCESO DE DX MASIVA No. {elemento.numeroOdeDX} !!</p>
                    } */}
                </div>
            </List.Header>
        </List.Item>
      </div>
    </div>
  )
};

const Lista = ({styles, empresaArchFE, list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} empresaArchFE={empresaArchFE} handleClickidLista={handleClickidLista} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      {nivel1Detalle}
    </div>
  )
};

const HomeCli2 = ({autorizacUA, styles, empresaArchFE, handleClick, list, handleClickidLista}) => {
  // console.log(list)
  //Traer autorizaciones
  const a0101 = autorizacUA.findIndex( autorizac => autorizac === "0101" );
  const a010101 = autorizacUA.findIndex( autorizac => autorizac === "010101" );
  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Clientes" btnNuevo={a010101!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />

        <Lista list={list} styles={styles} empresaArchFE={empresaArchFE} handleClickidLista={a0101!==-1?handleClickidLista:()=>{}}/>
      </List>
    </div>
  )
};

// export default graphql(queries.query.allClientes)(HomeCli2)
export default HomeCli2
